import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { Level } from "../level.entity";
import { LevelDTO } from "./level.dto";

export class LevelAdapter {
    convertDtoToEntity(dtoObj: LevelDTO,  isUpdate: boolean = false ): Level {
        try {
            const entityObj = new Level();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.levelCode = dtoObj.levelCode;
            entityObj.levelName = dtoObj.levelName;
            if (dtoObj.levelId) {
                entityObj.levelId = dtoObj.levelId;
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.isActive = dtoObj.isActive;
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }

    public convertEntityToDto(levelObject: Level): LevelDTO {
        const levelDTO= new LevelDTO;
        levelDTO.levelId = levelObject.levelId;
        levelDTO.levelCode = levelObject.levelCode;
        levelDTO.levelName = levelObject.levelName;
        levelDTO.isActive = levelObject.isActive;
        levelDTO.createdAt = levelObject.createdAt;
        levelDTO.updatedAt = levelObject.updatedAt;
        levelDTO.createdUser = levelObject.createdUser;
        levelDTO.updatedUser = levelObject.updatedUser;
        levelDTO.versionFlag = levelObject.versionFlag;
        return levelDTO;
      }
}